// @flow

import styled from 'styled-components';

export const VoucherTips = styled.div`
  padding: 16px 12px 16px 54px;
  border-radius: 8px;
  background: rgb(248, 248, 249);
  color: rgb(115, 128, 147);
`;

export const VoucherTipsTitle = styled.h2`
  font-size: 1.3em;
  text-align: center;
  margin-bottom: 24px;
`;

export const VoucherTipsItems = styled.ol`
  list-style: none;
  font-family: ${props => props.theme.fontFamily.sansSerif};
`;

export const VoucherTipItem = styled.li`
  line-height: 1.5em;
  min-height: 2.6em;
  margin: 0 0 2em 0;
  counter-increment: spei-tips-counter;
  position: relative;

  &:last-child {
    margin: 0;
  }

  &::before {
    content: '';
    background-color: rgb(227, 230, 233);
    position: absolute;
    width: 0.3em;
    top: 1em;
    bottom: -2em;
    left: -1.9em;
  }

  &:nth-last-child(1)::before {
    content: none;
  }

  ::after {
    content: counter(spei-tips-counter);

    background-color: rgb(227, 230, 233);
    outline: 4px solid rgb(248, 248, 249);

    font-size: 1.2em;
    font-weight: bold;

    position: absolute;

    --size: 1.8em;
    left: calc(-1 * var(--size) - 10px);
    line-height: var(--size);
    width: var(--size);
    height: var(--size);

    top: 0;
    border-radius: 50%;
    text-align: center;
  }
`;
